import { api, ReactQueryOptions } from '@api';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
import { useShowToast } from '@hooks/useShowToast';
type optionsType = ReactQueryOptions['UserManager']['updateBio'];
export const useUpdateBio = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    updateProfileData
  } = useInvalidate();
  return api.UserManager.updateBio.useMutation({
    mutationKey: ['UserManager.updateBio'],
    onSuccess: () => {
      updateProfileData();
    },
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    ...options
  });
};